<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g form">
                    <input type="radio" name="star" id="star5" value="5" v-model="value"><label for="star5"></label>
                    <input type="radio" name="star" id="star4" value="4" v-model="value"><label for="star4"></label>
                    <input type="radio" name="star" id="star3" value="3" v-model="value"><label for="star3"></label>
                    <input type="radio" name="star" id="star2" value="2" v-model="value"><label for="star2"></label>
                    <input type="radio" name="star" id="star1" value="1" v-model="value"><label for="star1"></label>
                </div>
                <div class="g fieldset">
                    <p>{{ $t('page.comment.send') }}</p>
                    <textarea v-model="mark" cols="30" rows="5"></textarea>
                    <div>
                        <div v-if="noAlert" class="cp input checkbox">
                            <input type="checkbox" checked>
                            <label for @click="noAlert = false">{{ this.$t('page.comment.alert') }}</label>
                        </div>
                        <div v-else class="cp input checkbox">
                            <input type="checkbox">
                            <label for @click="noAlert = true">{{ this.$t('page.comment.alert') }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){

            return {
                max: 5,
                value: 5,
                mark: '',
                noAlert: false,
            }
        },
        computed: {
             ...mapState([
                'user',
            ]),
            haveAction: function() {
                return this.content.action && typeof this.content.action === 'function';
            },
            btns: function(){
                let $action = {
                        text: this.$t('page.shoppingcart.start.send'),
                        themes: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: this.$t('site.func.popupclose'),
                        func: 'close',
                    }

                return [
                    $action,
                    $cancel,
                ]
            },
        },
        methods: {
            ...mapMutations([
                'pushNotification',
                'setComment',
            ]),
            action: function(){

                let _url = this.$siteTool.apiUrl({
                        class: 'Data',
                        func: 'Feedback',
                    }),
                    $condition = {
                        inqtno: this.content.inqtno,
                        score: this.value,
                        comment: this.mark,
                    }

                this.$http.post(_url, $condition);

                this.pushNotification({
                    type: 'notification',
                    content: {
                        html: this.$t('page.comment.notification'),
                        status: 'success'
                    }
                });

                if( this.noAlert ) {
                    this.setComment(90);
                }else {
                    this.setComment();
                }

                this.close();
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);

                this.runCallBack();
            },
            runCallBack: function(){
                let $content = this.content,
                    $_callback = $content.callback;

                if( $_callback ) {
                    $_callback();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .form {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row-reverse;

        input[type=radio] {
            display: none;
        }
        
        label {
            background-image: url('~/salenet/images/css/star-null.png');
            width: 30px;
            height: 25px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }

        input[type=radio]:checked ~ label {
            background-image: url('~/salenet/images/css/star-select.png')
        }

        label:hover, label:hover ~ label {
            background-image: url('~/salenet/images/css/star-select.png');
        }
    }
</style>
